/**
 * Featured categories carousel: horizontal scroll via prev/next arrows.
 * Runs per [data-featured-categories] container.
 */
function initFeaturedCategories(section) {
  const track = section.querySelector('[data-featured-categories-track]');
  const prevBtn = section.querySelector('[data-featured-categories-prev]');
  const nextBtn = section.querySelector('[data-featured-categories-next]');

  if (!track || (!prevBtn && !nextBtn)) return;

  const cards = section.querySelectorAll('[data-featured-categories-card]');
  if (cards.length === 0) return;

  function getStep() {
    const cardWidth = cards[0].offsetWidth;
    const styles = window.getComputedStyle(track);
    const gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;

    return cardWidth + gap;
  }

  function scrollBy(direction) {
    const step = getStep();
    const current = track.scrollLeft;
    const next = direction === 'next' ? current + step : current - step;
    track.scrollTo({ left: Math.max(0, next), behavior: 'smooth' });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', () => scrollBy('prev'));
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => scrollBy('next'));
  }
}

function initFeaturedCategoriesSections() {
  document.querySelectorAll('[data-featured-categories]').forEach((section) => {
    if (section.querySelector('[data-featured-categories-track]')) {
      initFeaturedCategories(section);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFeaturedCategoriesSections);
} else {
  initFeaturedCategoriesSections();
}
